/*
Cabinet Hinges
  --closeType <string::enum> | ['Soft', 'Free Swing', 'Self']
  --degreeOfOpen <float> | degrees
  --attachmentMethod <string::enum> | ['Insert', 'Screw', 'Press In']
  --overlay <string::enum> ['Inset', 'Full', 'Half']
  --loadWeight <float> | pounds
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Hinges'
const id = 'kYdLVb8hKfiQUYY8p28C'

export default {
  name,
  id,
  filters,
  headers,
  form
}
